import { Button } from "@/components/Button"
import { Input } from "@/components/Form/Input"
import { Modal } from "@/components/Modal"
import { useForm } from "react-hook-form"

interface Props {
  show: boolean
  onClose: VoidFunction
  data: { payWith?: string; total: number; currency?: string }
  onSend: (code: string) => void
  loading?: boolean
}
export const ConfirmModal = ({ show, onClose, data, onSend, loading }: Props) => {
  const { handleSubmit, control } = useForm<{ code: string }>()
  return (
    <Modal show={show} onClose={onClose} title="Confirm Transfer" className="w-full sm:w-auto sm:min-w-[450px]">
      <form noValidate autoComplete="off" onSubmit={handleSubmit(({ code }) => onSend(code))}>
        <div className="p-4 border text-base mt-4">
          <div className="flex justify-between items-center">
            <p className="text-gray-400">Pay with</p>
            <span className="text-black">{data.payWith}</span>
          </div>
          <div className="flex justify-between items-center mt-4">
            <p className="text-gray-400">Total</p>
            <span className="text-black">
              {Number(data.total ?? 0).toFixed(2)} {data.currency}
            </span>
          </div>
        </div>
        <Input.Form
          {...{ control, name: "code" }}
          label="Confirm with code"
          className="mt-3 [&>span:first-of-type]:text-base"
          required
          rules={{
            maxLength: { value: 16, message: "Code must be 16 characters long" },
          }}
        />
        <div className="flex gap-2 md:gap-3 child:flex-1 mt-4 flex-col-reverse md:flex-row">
          <Button color="inherit" to="/iban/payments">
            Cancel Order
          </Button>
          <Button type="submit" loading={loading}>
            Send Transfer
          </Button>
        </div>
      </form>
    </Modal>
  )
}
